import { GOOGLE_FONTS, useGoogleFonts } from '~/client/common/hooks/use-google-fonts.hook'
import { EventSpaceList } from '~/shared/event/event.types'
import React from 'react'
import MTBackground from '~/assets/images/presentations/mt/background.png'
import mtLogo from '~/assets/images/presentations/mt/mtlogo.svg'
import { formatUtcDateLongFromUnknown } from '~/shared/common/date'

const Container: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div
    style={{
      backgroundColor: '#024b36',
      width: '1920px',
      height: '1080px',
      minWidth: '1920px',
      minHeight: '1080px',
      maxWidth: '1920px',
      maxHeight: '1080px',
      padding: 0,
      margin: 0,
      fontFamily: 'Lato, sans-serif',
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
    }}
  >
    {children}
  </div>
)

interface MTSlideCoverProps {
  eventSpaceList: EventSpaceList
}

const MTSlideCover: React.FC<MTSlideCoverProps> = ({ eventSpaceList }) => {
  useGoogleFonts([GOOGLE_FONTS.LATO, GOOGLE_FONTS.MAITREE])

  if (!eventSpaceList) {
    return null
  }

  // Get the first event date if available
  const eventDate = formatUtcDateLongFromUnknown(eventSpaceList.event_space_list_dates?.[0]?.start_date, 'en-US') ?? ''

  return (
    <Container>
      {/* M&T Bank Logo */}
      <div
        style={{
          position: 'absolute',
          top: '60px',
          left: '106px',
          fontFamily: 'Arial, sans-serif',
          fontSize: '45px',
          fontWeight: 'bold',
          color: '#FFFFFF',
          letterSpacing: '-2px',
        }}
      >
        <img src={mtLogo} alt="M&T" />
      </div>

      {/* Decorative Ampersand Graphic (from provided image) */}
      <img
        src={MTBackground}
        alt="M&T decorative ampersand"
        style={{
          position: 'absolute',
          top: 0,
          left: '831px',
          width: '1133px',
          height: '1085px',
          objectFit: 'cover',
          pointerEvents: 'none',
        }}
      />

      {/* Main Title */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: '106px',
          maxWidth: '812px',
        }}
      >
        <div
          style={{
            fontFamily: 'Maitree, serif',
            fontSize: '100px',
            fontWeight: 'bold',
            color: '#FFFFFF',
            lineHeight: '100px',
            marginBottom: '0',
          }}
        >
          {eventSpaceList.name || 'End of Summer Associate Program Reception'}
        </div>
      </div>

      {/* Venue Options Label */}
      <div
        style={{
          position: 'absolute',
          top: '827px',
          left: '106px',
        }}
      >
        <div
          style={{
            fontFamily: 'Lato, sans-serif',
            fontSize: '45px',
            fontWeight: 600,
            color: '#FFFFFF',
            letterSpacing: '0',
          }}
        >
          VENUE OPTIONS
        </div>
      </div>

      {/* Date (Subtitle) */}
      {eventDate && (
        <div
          style={{
            position: 'absolute',
            top: '920px',
            left: '106px',
          }}
        >
          <div
            style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '30px',
              fontWeight: 600,
              color: '#FFFFFF',
            }}
          >
            {eventDate}
          </div>
        </div>
      )}
    </Container>
  )
}

export default MTSlideCover
